const userAgent = navigator.userAgent;
const isFireFox = /firefox/i.test(userAgent);

export default isFireFox;